import { Link } from 'react-router-dom';
import { BackArrowIcon } from '../components/BackArrowIcon';
import { PublicHeader, publicHeaderTopPaddingClass } from '../components/PublicHeader';
import { PublicFooter } from '../components/PublicFooter';

/**
 * Content aligned with `documents/Web Version/website-standalone.html` → `AboutUs` component.
 */
export function AboutPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <PublicHeader />
      <main className={`flex-1 px-6 pb-12 ${publicHeaderTopPaddingClass} pt-8`}>
        <article className="mx-auto max-w-3xl">
          <Link
            to="/"
            className="mb-8 inline-flex items-center gap-1.5 text-sm font-bold text-blue-600 hover:underline"
          >
            <BackArrowIcon />
            Back to home
          </Link>
          <h1 className="mb-12 text-4xl font-black tracking-tight text-slate-900">About Us</h1>

          <div className="space-y-12 text-slate-600">
            <section>
              <h2 className="mb-6 text-2xl font-black text-blue-600">Our Team</h2>
              <p className="text-lg font-medium leading-relaxed">
                We are a team of young and dynamic professionals with over 20+ years of collective experience in IT
                product development and Sales &amp; Marketing. Our diverse background allows us to bridge the gap between
                complex technology and real-world business needs, ensuring that BidMaster remains at the forefront of
                procurement innovation.
              </p>
            </section>

            <section>
              <h2 className="mb-6 text-2xl font-black text-blue-600">Our Vision</h2>
              <div className="rounded-[32px] border border-blue-100 bg-blue-50 p-8">
                <p className="text-xl font-bold italic leading-relaxed text-slate-900">
                  &ldquo;To revolutionize the global procurement landscape by providing a transparent, efficient, and
                  real-time bidding ecosystem that empowers businesses to achieve their highest potential.&rdquo;
                </p>
              </div>
            </section>

            <section>
              <h2 className="mb-6 text-2xl font-black text-blue-600">Core Values</h2>
              <div className="grid gap-6 sm:grid-cols-2">
                <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
                  <h3 className="mb-2 text-sm font-black uppercase tracking-wider text-slate-900">Transparency</h3>
                  <p className="text-sm">
                    We believe in complete openness in every transaction, ensuring trust between all parties involved in
                    the bidding process.
                  </p>
                </div>
                <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
                  <h3 className="mb-2 text-sm font-black uppercase tracking-wider text-slate-900">Innovation</h3>
                  <p className="text-sm">
                    Constantly pushing the boundaries of what&apos;s possible in procurement technology to deliver
                    cutting-edge solutions.
                  </p>
                </div>
                <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
                  <h3 className="mb-2 text-sm font-black uppercase tracking-wider text-slate-900">Efficiency</h3>
                  <p className="text-sm">
                    Optimizing time and costs for our clients through streamlined workflows and real-time data insights.
                  </p>
                </div>
                <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
                  <h3 className="mb-2 text-sm font-black uppercase tracking-wider text-slate-900">Integrity</h3>
                  <p className="text-sm">
                    Upholding the highest ethical standards in our products, our partnerships, and our team culture.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </main>
      <PublicFooter />
    </div>
  );
}
